import { Controller, useFormContext } from 'react-hook-form';
import { fieldToUppercase } from '@shared/helpers';
import { Card, TextInput } from '@shared/ui';
import * as st from './styles.module.scss';

export const Language = (): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  // const errorMessage = (errors.language?.message as string) ?? '';

  return (
    <fieldset>
      <div className={st.header}>
        <h3>Язык</h3>
        {/* <p>{errorMessage}</p> */}
      </div>
      <Card className={st.card}>
        <div className={st.language__field}>
          <Controller
            name="language"
            control={control}
            render={({ field }) => (
              <TextInput
                className={st.input}
                label=""
                fullWidth
                isValid={!!errors.language}
                {...field}
                onChange={(e) => {
                  const value = fieldToUppercase(e);
                  field.onChange(value);
                }}
              />
            )}
          />
        </div>
      </Card>
    </fieldset>
  );
};
